/* The Cove Charleston — Cove Gives interactions */
(() => {
  const initAccordions = (scope = document) => {
    scope.querySelectorAll('[data-cove-gives-accordion]').forEach((root) => {
      if (root.dataset.coveGivesReady === 'true') return;
      root.dataset.coveGivesReady = 'true';
      if (root.dataset.singleOpen !== 'true') return;
      root.querySelectorAll('details').forEach((detail) => {
        detail.addEventListener('toggle', () => {
          if (!detail.open || detail.hidden) return;
          root.querySelectorAll('details[open]').forEach((other) => {
            if (other !== detail) other.removeAttribute('open');
          });
        });
      });
    });
  };

  const initFilters = (scope = document) => {
    scope.querySelectorAll('[data-cove-gives-filters]').forEach((filters) => {
      if (filters.dataset.coveGivesFiltersReady === 'true') return;
      filters.dataset.coveGivesFiltersReady = 'true';
      const section = filters.closest('.cove-gives');
      if (!section) return;
      const events = Array.from(section.querySelectorAll('[data-cove-gives-event]'));
      const empty = section.querySelector('[data-cove-gives-empty]');
      const buttons = Array.from(filters.querySelectorAll('[data-cove-gives-filter]'));

      const applyFilter = (filter) => {
        let visible = 0;
        events.forEach((event) => {
          const status = event.dataset.eventStatus || 'coming';
          const show = filter === 'all' || status === filter;
          event.hidden = !show;
          if (!show) event.removeAttribute('open');
          if (show) visible += 1;
        });
        if (empty) empty.hidden = visible !== 0;
        buttons.forEach((button) => {
          const active = button.dataset.coveGivesFilter === filter;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      };

      buttons.forEach((button) => {
        button.addEventListener('click', () => applyFilter(button.dataset.coveGivesFilter || 'all'));
      });
    });
  };

  const encodeBase64Url = (value) => {
    const bytes = new TextEncoder().encode(value);
    let binary = '';
    bytes.forEach((byte) => { binary += String.fromCharCode(byte); });
    return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
  };

  const initContributions = (scope = document) => {
    scope.querySelectorAll('[data-cove-contribution-card]').forEach((card) => {
      if (card.dataset.coveContributionReady === 'true') return;
      card.dataset.coveContributionReady = 'true';

      const recognition = card.querySelector('[data-cove-recognition]');
      const nameWrap = card.querySelector('[data-cove-recognition-name]');
      const nameInput = card.querySelector('[data-cove-recognition-name-input]');
      const error = card.querySelector('[data-cove-recognition-error]');
      const amounts = card.querySelector('[data-cove-contribution-amounts]');
      const links = Array.from(card.querySelectorAll('[data-cove-contribution-link]'));

      const syncRecognition = () => {
        const active = Boolean(recognition && recognition.checked);
        if (nameWrap) nameWrap.hidden = !active;
        if (nameInput) {
          nameInput.required = active;
          if (!active) {
            nameInput.removeAttribute('aria-invalid');
            if (error) error.hidden = true;
          }
        }
      };

      if (recognition) {
        recognition.addEventListener('change', syncRecognition);
        syncRecognition();
      }
      if (nameInput) {
        nameInput.addEventListener('input', () => {
          if (nameInput.value.trim()) {
            nameInput.removeAttribute('aria-invalid');
            if (error) error.hidden = true;
          }
        });
      }

      links.forEach((link) => {
        link.addEventListener('click', (event) => {
          const allowRecognition = Boolean(recognition && recognition.checked);
          const recognitionName = nameInput ? nameInput.value.trim() : '';

          if (allowRecognition && !recognitionName) {
            event.preventDefault();
            if (nameWrap) nameWrap.hidden = false;
            if (nameInput) {
              nameInput.setAttribute('aria-invalid', 'true');
              nameInput.focus();
            }
            if (error) error.hidden = false;
            return;
          }

          const checkoutBase = link.dataset.checkoutBase;
          if (!checkoutBase) return;
          event.preventDefault();

          const purpose = amounts?.dataset.covePurpose || 'The Cove Gives';
          const properties = {
            'Recognition permission': allowRecognition ? 'Yes' : 'No'
          };
          if (allowRecognition) properties['Recognition name'] = recognitionName;

          const url = new URL(checkoutBase, window.location.origin);
          url.searchParams.set('properties', encodeBase64Url(JSON.stringify(properties)));
          url.searchParams.set('attributes[Cove Gives purpose]', purpose);
          window.location.assign(url.toString());
        });
      });
    });
  };


  const initPhoneValidation = (scope = document) => {
    scope.querySelectorAll('[data-cove-phone]').forEach((input) => {
      if (input.dataset.covePhoneReady === 'true') return;
      input.dataset.covePhoneReady = 'true';

      const errorMessage = input.dataset.covePhoneError || 'Please enter a valid 10-digit U.S. phone number.';
      const getDigits = () => input.value.replace(/\D/g, '');

      const isValidPhone = () => {
        const digits = getDigits();
        if (!digits.length) return true;
        return digits.length === 10 || (digits.length === 11 && digits.startsWith('1'));
      };

      const sanitizePhone = () => {
        input.value = input.value.replace(/[^0-9()+ .-]/g, '');
      };

      const formatValidPhone = () => {
        const digits = getDigits();
        if (!isValidPhone() || !digits.length) return;
        const national = digits.length === 11 ? digits.slice(1) : digits;
        const prefix = digits.length === 11 ? '+1 ' : '';
        input.value = `${prefix}(${national.slice(0, 3)}) ${national.slice(3, 6)}-${national.slice(6, 10)}`;
      };

      const validatePhone = () => {
        input.setCustomValidity(isValidPhone() ? '' : errorMessage);
      };

      input.addEventListener('input', () => {
        sanitizePhone();
        validatePhone();
      });
      input.addEventListener('blur', () => {
        validatePhone();
        formatValidPhone();
      });
      input.addEventListener('invalid', validatePhone);
      validatePhone();
    });
  };


  // Cove Gives same-page navigation uses the browser's native anchor behavior.
  // This avoids multiple competing scroll animations and makes every first click reliable.
  // CSS supplies smooth scrolling and sticky-header offsets. JavaScript only prepares
  // the nomination dropdown when an event-specific nomination link is used.
  const navigationState = window.__coveGivesNavigationState || {
    pendingNomination: ''
  };
  window.__coveGivesNavigationState = navigationState;

  const syncNominationPrograms = () => {
    const selects = document.querySelectorAll('[data-cove-nomination-program-select]');
    if (!selects.length) return;

    const openTitles = Array.from(document.querySelectorAll('[data-cove-gives-event][data-nomination-status="open"]'))
      .map((event) => (event.dataset.eventTitle || '').trim())
      .filter(Boolean)
      .filter((title, index, list) => list.indexOf(title) === index);

    selects.forEach((select) => {
      select.querySelectorAll('option[data-cove-event-option]').forEach((option) => option.remove());
      const other = select.querySelector('[data-cove-nomination-other]');
      openTitles.forEach((title) => {
        const option = document.createElement('option');
        option.value = title;
        option.textContent = title;
        option.dataset.coveEventOption = 'true';
        if (other) select.insertBefore(option, other);
        else select.appendChild(option);
      });

      if (navigationState.pendingNomination && openTitles.includes(navigationState.pendingNomination)) {
        select.value = navigationState.pendingNomination;
      }
    });
  };

  const prepareNominationTarget = (eventTitle) => {
    if (!eventTitle) return;
    navigationState.pendingNomination = eventTitle;
    syncNominationPrograms();
    const select = document.querySelector('[data-cove-nomination-program-select]');
    if (select && Array.from(select.options).some((option) => option.value === eventTitle)) {
      select.value = eventTitle;
    }
  };

  const initNominationLinks = (scope = document) => {
    if (!scope || !scope.querySelectorAll) return;
    scope.querySelectorAll('[data-cove-nominate-event]').forEach((link) => {
      if (link.dataset.coveNominationLinkReady === 'true') return;
      link.dataset.coveNominationLinkReady = 'true';
      link.addEventListener('click', () => {
        prepareNominationTarget((link.dataset.coveNominateEvent || '').trim());
      });
    });
  };

  const init = (scope = document) => {
    initNominationLinks(scope);
    syncNominationPrograms();
    initPhoneValidation(scope);
    initAccordions(scope);
    initFilters(scope);
    initContributions(scope);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
